import { MenuRecipe } from '../queries/common/types'
import { Recipe, RecipeCoreId, RecipeUUID } from './types'

export const fromAPIRecipe = (recipe: MenuRecipe): Recipe => ({
  id: recipe.id as RecipeUUID,
  coreId: recipe.core_recipe_id as RecipeCoreId,
  name: recipe.name,
  dietaryClaims: recipe.dietary_claims,
  dietType: recipe.diet_type || null,
  fiveADay: recipe.five_a_day,
  foodBrand: recipe.food_brand,
  images: recipe.images,
  invalidPreference: recipe.invalid_preference,
  isAvailable: recipe.is_available,
  isOffered: true, // Recipes returned from the API are offered by definition
  merchandisingTags: {
    availability: recipe.merchandising_tags.availability
      ? {
          name: recipe.merchandising_tags.availability.name,
          color: recipe.merchandising_tags.availability.color,
          backgroundColor: recipe.merchandising_tags.availability.background_color,
        }
      : null,
    tagline: recipe.merchandising_tags.tagline
      ? {
          name: recipe.merchandising_tags.tagline.name,
          color: recipe.merchandising_tags.tagline.color,
          backgroundColor: recipe.merchandising_tags.tagline.background_color,
        }
      : null,
  },
  nutritionalInformation: {
    perPortion: {
      energyKcal: recipe.nutritional_information.per_portion.energy_kcal,
      carbsMg: recipe.nutritional_information.per_portion.carbs_mg,
      fatMg: recipe.nutritional_information.per_portion.fat_mg,
      proteinMg: recipe.nutritional_information.per_portion.protein_mg,
      saltMg: recipe.nutritional_information.per_portion.salt_mg,
    },
  },
  prepTime: recipe.prep_time,
  rating: recipe.rating,
  shelfLife: recipe.shelf_life
    ? {
        maxDays: recipe.shelf_life.max_days,
        minDays: recipe.shelf_life.min_days,
      }
    : null,
  spiceLevel: recipe.spice_level,
  surcharge: recipe.surcharge
    ? {
        name: recipe.surcharge.name,
        price: recipe.surcharge.price,
        pricePerPortion: recipe.surcharge.price_per_portion,
      }
    : null,
})
